import React from "react";
import './more-about-amc.css';
// componentes y estilos de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'; // Si quieres las flechitas
import 'swiper/css/pagination'; // Si quieres los puntitos abajo
// módulos de funcionalidad
import { Navigation, Pagination } from 'swiper/modules';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MoreAboutAmc = () => {
    const [tInformation] = useTranslation("information");
    const { i18n } = useTranslation();
    const isSpanish = i18n.language.startsWith("es");

    const cardsData = [
        {
            id: 1,
            title: tInformation("more-about-amc.subtitle-1"),
            description: tInformation("more-about-amc.text-1"),
            url: isSpanish ? "/nosotros/aeromexico-cargo" : "/about-us/aeromexico-cargo",
        },
        {
            id: 2,
            title: tInformation("more-about-amc.subtitle-2"),
            description: tInformation("more-about-amc.text-2"),
            url: isSpanish ? "/estaciones/nacionales" : "/stations/nationals",
        },
        {
            id: 3,
            title: tInformation("more-about-amc.subtitle-3"),
            description: tInformation("more-about-amc.text-3"),
            url: isSpanish ? "/nosotros/skyteam" : "/about-us/skyteam",
        },
    ];

    return(
        <div className="container-fluid more-about-container">
            <div className="row custom-padding-2">
                <div className="col more-about-title">
                    <p>{tInformation("more-about-amc.title")}</p>
                </div>
            </div>

            <div className="row custom-padding mt-2">
                <div className="col my-4 position-relative">
                
                    <div className="custom-prev-more nav-btn-more d-flex d-md-none">
                        <FaLongArrowAltLeft size={18} />
                    </div>
                    <div className="custom-next-more nav-btn-more d-flex d-md-none">
                        <FaLongArrowAltRight size={18} />
                    </div>

                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={0} // Espacio entre cards (en px)
                        navigation={{
                            nextEl: '.custom-next-more',
                            prevEl: '.custom-prev-more',
                        }}
                        breakpoints={{
                            // Configuración para Celular (>= 320px)
                            320: {
                                slidesPerView: 1, // Muestra 1 card
                                spaceBetween: 10,
                                enabled: true,
                            },
                            // Configuración para Tablet (>= 768px)
                            768: {
                                slidesPerView: 3, // Muestra 2 cards (¡Lo que pediste!)
                                spaceBetween: 20,
                                enabled: false,
                            }
                        }}
                        className="mySwiper"
                    >
                        {/* Aquí iteramos TODAS las cards, sin separar en grupos */}
                        {cardsData.map((card, index) => (
                            <SwiperSlide key={index} style={{ height: 'auto' }}>
                                {/* El 'height: auto' en el slide es clave para que Flexbox funcione dentro */}
                                <div className="card-more-about"> 
                                    <div className="mb-0">
                                        <div className="card-more-about-title">
                                            <h5>{card.title}</h5>
                                        </div>
                                        <div className="card-more-about-text">
                                            <p>{card.description}</p>
                                        </div>
                                    </div>
                                    <Link to={card.url} className="btn-transparent mt-3 text-decoration-none">
                                        {tInformation("more-about-amc.btn-discover")}
                                    </Link>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default MoreAboutAmc;